import { motion } from "framer-motion";
import { useContext, useEffect, useRef, useState } from "react";
import { ThemeContext } from "../../contexts/ThemeProvider";
import { LanguageContext } from "../../contexts/LanguageProvider";
import FeaturedButton from "./FeatureButton";
import { icons } from "lucide-react";
import { iconsMap } from "../icons";

export const PhoneGif = () => {
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        delayChildren: 1.2,
        staggerChildren: 0.2,
      },
    },
  };

  const { t } = useContext(LanguageContext);
  const [counter, setCounter] = useState<number>(1);
  const [stopCounter, setStopCounter] = useState<boolean>(false);
  const { language } = useContext(LanguageContext);
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  // const intervalRef = useRef(
  //   setInterval(() => {
  //     setCounter((prev) => (prev + 1) % 7);
  //   }, 10000)
  // );

  // useEffect(() => {
  //   if (stopCounter) clearInterval(intervalRef.current);
  // }, [stopCounter]);

  // useEffect(() => {
  //   return () => clearInterval(intervalRef.current);
  // }, []);

  return (
    <>
      {/* mobile */}
      <motion.div
        variants={containerVariants}
        className="max-w-[650px] flex md:hidden justify-center relative"
        initial={{ x: 100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="w-full max-w-[250px] relative flex align-center justify-center p-4 rounded-2xl text-xs text-gray-950 font-semibold">
          <div
            className="relative w-full h-[500px] overflow-hidden rounded-2xl"
            style={{ margin: "0 auto" }}
          >
            <video
              key={`${counter + 1}-${language}-${isSafari ? "mov" : "webm"}`}
              autoPlay
              loop
              muted
              playsInline
              disablePictureInPicture
              controlsList="nodownload nofullscreen noremoteplayback"
              style={{
                width: "auto",
                height: "100%",
                scale: 1,
                position: "absolute",
                top: "0",
                left: "50%",
                transform: "translateX(-50%)",
                pointerEvents: "none",
                objectFit: "cover",
                objectPosition: "center",
              }}
            >
              {isSafari ? (
                <source
                  src={`/videos/${counter + 1}-${language}.mov`}
                  type="video/quicktime"
                />
              ) : (
                <source
                  src={`/videos/${counter + 1}-${language}.webm`}
                  type="video/webm"
                />
              )}
            </video>
          </div>

          <FeaturedButton
            index={1}
            top="50%"
            left="-64px"
            label={t("home-hero-feature-1")}
            trigger={counter === 0}
            onClick={() => {
              setCounter(0);
              setStopCounter(true);
            }}
            icon={iconsMap["leaves"]}
          />

          <FeaturedButton
            index={2}
            top="30%"
            left="-64px"
            label={t("home-hero-feature-2")}
            trigger={counter === 1}
            onClick={() => {
              setCounter(1);
              setStopCounter(true);
            }}
            icon={iconsMap["attendance"]}
          />

          <FeaturedButton
            index={3}
            bottom="80%"
            left="-64px"
            onClick={() => {
              setCounter(2);
              setStopCounter(true);
            }}
            label={t("home-hero-feature-4")}
            trigger={counter === 2}
            icon={iconsMap["resources"]}
          />

          <FeaturedButton
            index={4}
            bottom="80%"
            right="-64px"
            onClick={() => {
              setCounter(3);
              setStopCounter(true);
            }}
            label={t("home-hero-feature-3")}
            trigger={counter === 3}
            icon={iconsMap["documents"]}
          />

          <FeaturedButton
            index={5}
            top="30%"
            right="-64px"
            onClick={() => {
              setCounter(4);
              setStopCounter(true);
            }}
            label={t("home-hero-feature-5")}
            trigger={counter === 4}
            icon={iconsMap["approvals"]}
          />
          <FeaturedButton
            index={6}
            bottom="0px"
            left="0%"
            onClick={() => {
              setCounter(5);
              setStopCounter(true);
            }}
            label={t("home-hero-feature-6")}
            trigger={counter === 5}
            icon={iconsMap["salary"]}
          />

          <FeaturedButton
            index={7}
            bottom="0"
            right="0%"
            onClick={() => {
              setCounter(6);
              setStopCounter(true);
            }}
            label={t("home-hero-feature-7")}
            trigger={counter === 6}
            icon={iconsMap["dossary"]}
          />
          <FeaturedButton
            index={8}
            top="50%"
            right="-64px"
            onClick={() => {
              setCounter(7);
              setStopCounter(true);
            }}
            label={t("home-hero-feature-8")}
            trigger={counter === 7}
            icon={iconsMap["team"]}
          />
        </div>
      </motion.div>

      {/* md and upper */}
      <motion.div
        variants={containerVariants}
        className="hidden max-w-[750px] md:flex justify-end relative pt-20"
        initial={{ x: 100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div
          className="w-full relative 
        rounded-2xl p-3 text-xs text-gray-950 font-semibold z-100 "
        >
          <div
            className="relative w-[300px] h-[600px] xl:w-[400px] xl:h-[700px] overflow-hidden rounded-2xl"
            style={{ margin: "0 auto" }}
          >
            <video
              key={`${counter + 1}-${language}-${isSafari ? "mov" : "webm"}`}
              autoPlay
              loop
              muted
              playsInline
              disablePictureInPicture
              controlsList="nodownload nofullscreen noremoteplayback"
              style={{
                width: "auto",
                height: "100%",
                position: "absolute",
                top: 0,
                left: "50%",
                transform: "translateX(-50%)",
                pointerEvents: "none",
                objectFit: "cover",
                objectPosition: "center",
              }}
            >
              {isSafari ? (
                <source
                  src={`/videos/${counter + 1}-${language}.mov`}
                  type="video/quicktime"
                />
              ) : (
                <source
                  src={`/videos/${counter + 1}-${language}.webm`}
                  type="video/webm"
                />
              )}
            </video>
          </div>

          <FeaturedButton
            index={1}
            top="50%"
            left="-64px"
            label={t("home-hero-feature-1")}
            trigger={counter === 0}
            onClick={() => {
              setCounter(0);
              setStopCounter(true);
            }}
            icon={iconsMap["leaves"]}
          />

          <FeaturedButton
            index={2}
            top="30%"
            left="-64px"
            label={t("home-hero-feature-2")}
            trigger={counter === 1}
            onClick={() => {
              setCounter(1);
              setStopCounter(true);
            }}
            icon={iconsMap["attendance"]}
          />

          <FeaturedButton
            index={3}
            bottom="80%"
            left="-64px"
            onClick={() => {
              setCounter(2);
              setStopCounter(true);
            }}
            label={t("home-hero-feature-4")}
            trigger={counter === 2}
            icon={iconsMap["resources"]}
          />

          <FeaturedButton
            index={4}
            bottom="80%"
            right="-64px"
            onClick={() => {
              setCounter(3);
              setStopCounter(true);
            }}
            label={t("home-hero-feature-3")}
            trigger={counter === 3}
            icon={iconsMap["documents"]}
          />

          <FeaturedButton
            index={5}
            top="30%"
            right="-64px"
            onClick={() => {
              setCounter(4);
              setStopCounter(true);
            }}
            label={t("home-hero-feature-5")}
            trigger={counter === 4}
            icon={iconsMap["approvals"]}
          />
          <FeaturedButton
            index={6}
            bottom="0px"
            left="0%"
            onClick={() => {
              setCounter(5);
              setStopCounter(true);
            }}
            label={t("home-hero-feature-6")}
            trigger={counter === 5}
            icon={iconsMap["salary"]}
          />

          <FeaturedButton
            index={7}
            bottom="0"
            right="0%"
            onClick={() => {
              setCounter(6);
              setStopCounter(true);
            }}
            label={t("home-hero-feature-7")}
            trigger={counter === 6}
            icon={iconsMap["dossary"]}
          />
          <FeaturedButton
            index={8}
            top="50%"
            right="-64px"
            onClick={() => {
              setCounter(7);
              setStopCounter(true);
            }}
            label={t("home-hero-feature-8")}
            trigger={counter === 7}
            icon={iconsMap["team"]}
          />
        </div>
      </motion.div>
    </>
  );
};
